/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-options.js
// module id = /tool/node_modules/webpack/buildin/amd-options.js
// module chunks = site__stratco